<template>
  <div class="confirm--twoFactor">
    <v-container class="px-0" fluid>
      <v-row justify="center" align="center" v-if="!this.twoFactor">
        <v-col cols="12" class="mb-5">
          <h1 class="primary--text font-weight-medium text-h5">
            {{ $t('twofactor_verify_title') }}
          </h1>
        </v-col>
      </v-row>
      <v-row justify="center" class="pa-3">
        <p
          class="header text-justify"
          v-html="$t('twofactor_verify_content_1')"
        />
        <p
          class="header text-justify"
          v-html="$t('twofactor_verify_content_2')"
        />
      </v-row>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="verify">
          <v-row
            align-content="center"
            justify="center"
            class="pa-3 pt-2 mt-2 input-width mx-auto text-center"
            :class="twoFactor ? 'mb-0' : 'mb-16'"
          >
            <ValidationProvider
              :name="$t('twofactor_verify_form_label')"
              rules="digits:6|required"
              v-slot="{ errors, failedRules }"
            >
              <label class="header primary--text">{{
                $t('twofactor_verify_form_label')
              }}</label>
              <v-otp-input
                length="6"
                class="input-width"
                :label="$t('twofactor_verify_form_label')"
                type="number"
                v-model="code"
                ref="otpInput"
                :error-messages="failedRules['digits']"
                autofocus
                @finish="verify"
                @keydown.native="preventNonNumbers"
              />
              <span v-if="failedRules['digits']" class="red--text text--lighten-1">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </v-row>
          <v-divider v-if="!twoFactor" class="ma-0 pa-0" />
          <v-row align-content="center">
            <v-col cols="12" class="d-flex twoFactor--buttons"
              :class="twoFactor? 'justify-center' : 'justify-space-between justify-md-end' ">
              <slot name="before"></slot>
              <slot name="button">
                <v-btn
                  color="secondary"
                  elevation="0"
                  :disabled="invalid || done"
                  :loading="loading"
                  @click="verify"
                >
                  {{ $t('btn_verify') }}
                </v-btn>
              </slot>
              <slot name="after" />
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-12" v-if="twoFactor">
            <a class="header primary--text text-decoration-none" @click="reset">
              {{ $t('twofactor_reset_link') }}
            </a>
          </v-row>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TwoFactorService from '@/services/twoFactor'

export default {
  data() {
    return {
      loading: false,
      code: '',
      done: false
    }
  },
  props: {
    twoFactor: {
      type: Boolean,
      required: false,
      default: false
    },
    showSnackbar: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('auth', ['user', 'tempUser']),
  },
  mounted() {
    this.focus()
  },
  methods: {
    ...mapActions('auth', ['setCurrentUser', 'setTempUser']),
    async verify() {
      this.loading = true
      try {
        await TwoFactorService.verify({ code: this.code })
        this.$emit('verify', true)
        if (this.showSnackbar) {
          this.$dialog.notify.success(this.$t('twofactor_verify_success'))
        }

        if (this.user) {
          this.user.twofactor_habilitated = true
          this.setCurrentUser(this.user)
        }
        if (this.tempUser) {
          this.tempUser.twofactor_habilitated = true
          this.setTempUser(this.tempUser)
        }
        this.done = true
      } catch (e) {
        this.done = false
        this.$dialog.notify.error(this.$t('twofactor_verify_error'))
      } finally {
        this.loading = false
      }
    },
    async reset() {
      this.$emit('reset')
    },
    focus() {
      this.$nextTick(() => {
        this.$refs.otpInput.focus()
      })
    },
    preventNonNumbers(event) {
      const invalidChars = ['+', '-', 'e', 'E', '.', ',']

      if (invalidChars.includes(event.key)) {
        event.preventDefault()
      }
    }
  }
}
</script>

<style scoped>
.confirm--twoFactor .row {
  margin: 0;
}

.header {
  text-align: center;
  font: normal normal 500 16px/22px 'Libre Franklin';
  letter-spacing: 0;
  color: #686f8d;
}

.input-width {
  max-width: 336px;
}
</style>
